import { api } from '@api'
import type { SetupFilter } from '../filter'
import type { Pagination } from '../index'
import { applyTextSearch } from '../utils/applyFilters'

export const handleGetDraft = async ({
  filters,
  userId,
  pagination,
}: { filters: SetupFilter; userId: string; pagination: Pagination }) => {

  let query = api().from('setup').select('*').eq('created_by', userId).eq('status', 'draft')

  // Drafts skip the enum filters (they're often incomplete) but still honour the search box
  query = applyTextSearch(query, filters)

  if (pagination.limit !== undefined && pagination.offset !== undefined) {
    query = query.range(pagination.offset, pagination.offset + pagination.limit - 1)
  }

  const { data } = await query
  return data || []
}
